import { IOrder } from '../../types/order'
import dayjs from 'dayjs'
import { Box } from '@mui/material'
import { Tag } from '../Tag'
import React from 'react'
import { ONLY_DATE_TIME_FORMAT } from '../../constants/global'

interface Props {
  order: IOrder
}

const PrintedTag = (props: Props) => {
  const { order } = props
  return <>
    {order.trackingCode &&
      <Box py={0.5} display={'flex'} flexWrap={'wrap'} gap={1}>
        <Tag color={order.printedAt ? 'info' : `warning`}>
          {order.printedAt ? <>
            <Box display={'flex'} alignItems={'center'} gap={1}>
              พิมพ์แล้ว<span style={{
              fontSize: 10,
              fontWeight: 500,
            }}>{dayjs(order.printedAt).format(ONLY_DATE_TIME_FORMAT)}</span>
            </Box>
          </> : `ยังไม่พิมพ์`}
        </Tag>
      </Box>
    }
  </>
}

export default PrintedTag
